module.exports = __webpack_public_path__ + "img/Executive-Suite.3fa49fec.jpg";